import { baseSubscription } from '@/utils/subscriptionHandler';
import ScheduleRowsAPI from '@/services/graphql/scheduleRows';
const subscribeForScheduleCommands = (variables, next) => baseSubscription({
  variables,
  next,
  subscriptionFunction: ScheduleRowsAPI.subscribeScheduleCommand,
  unsubscribe: false,
},);
export { subscribeForScheduleCommands };
